import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import pickBy from 'lodash/pickBy'
import isEmpty from 'lodash/isEmpty'
import Icon from 'components/common/Icon'

//* Helpers
import { getPageNumbers } from './functions'

//* Style
import PaginationStyle from './style'

const Pagination = ({ total, pageSize, onCategoryChange, pageNumbersToShow, prevIconName = 'arrow', nextIconName = 'arrow' }) => {
	const router = useRouter()

	//! State
	const [hasRouter, setHasRouter] = useState(false)

	useEffect(() => {
		setHasRouter(true)
	}, [router])

	//! Router
	if (!hasRouter) return null
	const query = pickBy({ ...(router.query || {}) }, (q) => !isEmpty(q))
	const currentPage = Number(query.page || 1)

	//! Page Size
	pageSize = Number(query.size) || pageSize
	const isLastPage = currentPage * pageSize >= total
	const pageNumbers = getPageNumbers({ currentPage, pageSize, total, pageNumbersToShow })

	return (
		<PaginationStyle className='pagination'>
			<div className={'pagination__list'}>
				<div
					className={`p p-2 prev-btn  ${currentPage === 1 ? 'disable' : ''}`}
					onClick={() => onCategoryChange('page', currentPage - 1)}
				>
					<Icon
						className={'p p-2'}
						name={prevIconName}
					/>
				</div>

				{pageNumbers.map((pageNumber, index) => {
					return pageNumber === '...' ? (
						<span
							className='dots p p-2'
							key={index}
							label='ellipsis'
						>
							&hellip;
						</span>
					) : (
						<div
							key={index}
							onClick={() => onCategoryChange('page', pageNumber)}
							className={`pagination-item font-montserrat p p-2 ${pageNumber === currentPage ? 'active' : ''}`}
						>
							{pageNumber}
						</div>
					)
				})}

				<div
					className={`p p3 next-btn  ${isLastPage ? 'disable' : ''}`}
					onClick={() => onCategoryChange('page', currentPage + 1)}
				>
					<Icon
						className={'p p-2'}
						name={nextIconName}
					/>
				</div>
			</div>
		</PaginationStyle>
	)
}

export default Pagination
